(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('BotNotificationDialogController', BotNotificationDialogController);

    BotNotificationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BotNotification'];

    function BotNotificationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BotNotification) {
        var vm = this;

        vm.botNotification = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.botNotification.id !== null) {
                BotNotification.update(vm.botNotification, onSaveSuccess, onSaveError);
            } else {
                BotNotification.save(vm.botNotification, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:botNotificationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
